import {
  EPS_PER_CEF,
  EPS_PER_SF,
  FPM_PER_CEF,
  FPM_PER_SF,
} from '../constants/spread';

/**
 * Calculate the EPS peak
 *
 * @param {number} workstations : Number of employees/workstations
 * @param {number} servers : Number of servers
 * @param {number} spread : Spread for range estimates
 * @returns {number}
 */

// [EPS_100_Paks]
export function EPSPeakCalculation(workstations, servers) {
  return (workstations * EPS_PER_CEF + servers * EPS_PER_SF) / 100;
}

/**
 * Calculate the FPM peak
 *
 * @param {number} workstations : Number of employees/workstations
 * @param {number} servers : Number of servers
 * @param {number} spread : Spread for range estimates
 * @returns {number}
 */
// [FPM_10k_Paks]
export function FPMPeakCalculation(workstations, servers) {
  return (workstations * FPM_PER_CEF + servers * FPM_PER_SF) / 10000;
}
